import { createAsyncThunk } from '@reduxjs/toolkit';
import type { Famille } from '@/types';
import api from '@/api/client';
import { setFamilles, editFamille, removeFamille } from '../slices/familleSlice';
import { setToast } from '../slices/toastSlice';

export const fetchFamilles = createAsyncThunk('famille/fetch', async (_, { dispatch, rejectWithValue }) => {
  try {
    const { data } = await api.get<{ data: Famille[] }>('/familles/');
    dispatch(setFamilles(data.data ?? []));
  } catch (err: unknown) {
    const message = err instanceof Error ? err.message : 'Erreur chargement familles';
    dispatch(setToast({ message, severity: 'error' }));
    return rejectWithValue(message);
  }
});

export const createFamille = createAsyncThunk<boolean, Partial<Famille>, { rejectValue: string }>(
  'famille/create',
  async (famille, { dispatch, rejectWithValue }) => {
    try {
      await api.post('/familles/', famille);
      await dispatch(fetchFamilles());
      dispatch(setToast({ message: 'Famille créée', severity: 'success' }));
      return true;
    } catch (err: unknown) {
      const message = err instanceof Error ? err.message : 'Erreur création';
      dispatch(setToast({ message, severity: 'error' }));
      return rejectWithValue(message);
    }
  }
);

export const updateFamille = createAsyncThunk<boolean, Famille, { rejectValue: string }>(
  'famille/update',
  async (famille, { dispatch, rejectWithValue }) => {
    try {
      await api.put(`/familles/${famille.id}`, famille);
      dispatch(editFamille(famille));
      dispatch(setToast({ message: 'Famille modifiée', severity: 'success' }));
      return true;
    } catch (err: unknown) {
      const message = err instanceof Error ? err.message : 'Erreur modification';
      dispatch(setToast({ message, severity: 'error' }));
      return rejectWithValue(message);
    }
  }
);

export const deleteFamille = createAsyncThunk<boolean, Famille, { rejectValue: string }>(
  'famille/delete',
  async (famille, { dispatch, rejectWithValue }) => {
    try {
      await api.delete(`/familles/${famille.id}`);
      dispatch(removeFamille(famille));
      dispatch(setToast({ message: 'Famille supprimée', severity: 'success' }));
      return true;
    } catch (err: unknown) {
      const message = err instanceof Error ? err.message : 'Erreur suppression';
      dispatch(setToast({ message, severity: 'error' }));
      return rejectWithValue(message);
    }
  }
);
